import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { LicenseInfo } from '@mui/x-license-pro';
import { MUI_THEME } from '@vedmarket/ui-kit';

import Navigator from './routes/navigator';
import { MUI_LICENSE_KEY } from './config/constants';
import '@vedmarket/ui-kit/ui-kit.css';
import './app.scss';
import './styles/common.scss';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const App = () => (
  <ThemeProvider theme={MUI_THEME}>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="app">
        <Navigator />
      </div>
    </LocalizationProvider>
  </ThemeProvider>
);

export default App;
